// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/reports/general-ledgers/trial-balance',
        component: () =>
            import('@/pages/[organisation]/reports/general-ledgers/trial-balance.vue'),
        name: 'reports.general-ledgers.trial-balance',
        meta: {
            loginRequired: true,
            permission: 'access.reports.financials.create-trial-balance-report',
        },
    },
    {
        path: '/:organisation/reports/general-ledgers/balance-sheet',
        component: () =>
            import('@/pages/[organisation]/reports/general-ledgers/balance-sheet.vue'),
        name: 'reports.general-ledgers.statement-of-position',
        meta: {
            loginRequired: true,
            permission: 'access.reports.financials.create-statement-of-position-report',
        },
    },

    {
        path: '/:organisation/reports/general-ledgers/income-statement',
        component: () =>
            import('@/pages/[organisation]/reports/general-ledgers/income-statement.vue'),
        name: 'reports.general-ledgers.income-statement',
        meta: {
            loginRequired: true,
            permission: 'access.reports.financials.create-income-statement-report',
        },
    },

    {
        path: '/:organisation/reports/general-ledgers/cashflow-statement',
        component: () =>
            import('@/pages/[organisation]/reports/general-ledgers/cashflow-statement.vue'),
        name: 'reports.general-ledgers.cashflow-statement',
        meta: {
            loginRequired: true,
            permission: 'access.reports.financials.create-cashflow-statement-report',
        },
    },
];
